// Zone1.js
import React from 'react';
import heartImg from '../ZonetablePoster/Heart.png'; 
import '../ZonetablePoster/allzones.css';

const videoLinks = [
  { title: "The PRUTL TIME-STORM (Hindi)", link: "https://youtu.be/-5Y96Cd6rFA" },
  { title: "The PRUTL TIME-STORM (English)", link: "https://youtu.be/slNYZ7e-yb0" },
  { title: "When Hearts Whisper Again (Hindi)", link: "https://youtu.be/S1JBi41GzaM" },
  { title: "When Hearts Whisper Again (English)", link: "https://youtu.be/5ULo0yXEauA" },
  { title: "EMI-e-motion (Hindi)", link: "https://youtu.be/6gj8HGOcLWo" },
  { title: "EMI-e-motion (English)", link: "https://youtu.be/C6kWX8S9RyY" },
  { title: "The Last Bus to Kailash (Hindi)", link: "https://youtu.be/2kLuQNvqlsM" },
  { title: "The Last Bus to Kailash (English)", link: "https://youtu.be/FUNmkWvqbtk" },
  { title: "THE MIRROR OF ERIS (Hindi)", link: "https://youtu.be/6a4YChEI3tY" },
  { title: "THE MIRROR OF ERIS (English)", link: "https://youtu.be/9GVfQ5YFrh0" }
];

const tableData = [
  {
    picture: heartImg,
    title: "When Hearts Whisper Again",
    genre: "Romance • Self-Discovery • Faith • Family • Sufi-inspired Reflection"
  }
];

function Zone1() {
  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px' }}>
      <h1 className="zone-title">Zone 1</h1>

      <table className="zone-table">
        <thead>
          <tr>
            <th>Museo Series</th>
            <th>Title</th>
            <th>Genre</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, idx) => (
            <tr key={idx}>
              <td><img src={item.picture} alt={item.title} /></td>
              <td className="title">{item.title}</td>
              <td className="genre">{item.genre}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Videos Grid */}
      <div className="episodes-grid" style={{ marginTop: '40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {videoLinks.map((video, index) => (
          <div key={index} className="episode-card" style={{ backgroundColor: '#111', padding: '10px', borderRadius: '8px' }}>
            <div className="episode-thumbnail" style={{ height: '180px' }}>
              <iframe
                width="100%"
                height="100%"
                src={video.link.replace("youtu.be/", "www.youtube.com/embed/")}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderRadius: '6px' }}
              ></iframe>
            </div>
            <div className="episode-title" style={{ marginTop: '8px', color: 'white', textAlign: 'center' }}>
              {video.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Zone1;
